module.exports = __webpack_public_path__ + "static/media/shutterstock_2047428986.ad6e074a.jpg";